import { combineReducers } from 'redux';
import * as actions from '../constants/actions';
import TableItem from '../models/TableItem';
import TableHeader from '../models/TableHeader';

const initialState = {
    rows: [],
    headers: [],
};

const formatAndSortRows = (rows, headers) => {
    const tableRows = rows.map(row => headers.map(header => new TableItem({
        attribute: header.key,
        value: row.attributes[header.key] ? row.attributes[header.key].toString() : '',
        errorMessage: row.errors[header.key],
        hasError: row.errors[header.key] !== '',
    })));

    const sortedTableRows = [];

    tableRows.forEach(row => {
        let hasError = false;

        row.forEach(item => {
            if (item.hasError) {
                hasError = true;
            }
        });

        if (hasError) {
            sortedTableRows.unshift(row);
        } else {
            sortedTableRows.push(row);
        }
    });

    return sortedTableRows;
};

const formatHeaders = headers => Object.keys(headers).map(key => new TableHeader({
    key,
    value: headers[key],
}));

export const installations = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_INSTALLATIONS_HEADERS:
            return Object.assign({}, state, {
                headers: formatHeaders(action.headers),
            });
        case actions.SET_INSTALLATIONS_ROWS:
            return Object.assign({}, state, {
                rows: formatAndSortRows(action.rows, state.headers),
            });
        default:
            return state;
    }
};

const installationsReducers = combineReducers({
    installations,
}, initialState);

export default installationsReducers;
